<ng-template #illegal>
  <app-page403></app-page403>
</ng-template>

<section *ngIf="!illegalUser; else illegal" name="data section" class="mb-5">
  <div class="col-md-10">
    <mat-form-field appearance="fill" class="matwidth">
      <mat-label>Enter a date range</mat-label>
      <mat-date-range-input [rangePicker]="picker">
        <input matStartDate placeholder="Start Date" #dateRangeStart>
        <input matEndDate placeholder="End Date" #dateRangeEnd>
      </mat-date-range-input>
      <mat-hint>MM/DD/YYYY - MM/DD/YYYY</mat-hint>
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-date-range-picker #picker></mat-date-range-picker>
    </mat-form-field>
    <br>
    <button class="btn-success" (click)="selectedDates(dateRangeStart, dateRangeEnd)">Submit</button>
  </div>
  <div class="col-md-10 my-5">
    <h3>Analysis Data</h3>
    <div *ngIf="previousAnalysisKeys.length > 0; else nodata">
      <card>
        <mat-form-field>
          <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Filter">
        </mat-form-field>
<!--        <div class="col-md-4 text-right">-->
<!--          <button class="btn btn-success btn-block" (click)="openPDF()">Download PDF</button>-->
<!--        </div>-->
        <div class="col-md-2 mb-2 float-right text-right">
          <button class="btn btn-success btn-block" (click)="openPDF()">Download PDF</button>
        </div>
        <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" matSort matSortStart="desc" id="reportData">
          <ng-container matColumnDef="projectCode">
            <th mat-header-cell *matHeaderCellDef > Project Code</th>
            <td mat-cell *matCellDef="let element">{{element.projectCode}}
          </ng-container>
          <ng-container matColumnDef="fileName">
            <th mat-header-cell *matHeaderCellDef>File Name</th>
            <td mat-cell *matCellDef="let element">
              <div *ngIf="element.analysis_status === 'Duplicate'; else linkRow">
                {{element.fileName}}
              </div>
              <ng-template #linkRow>
                <a [routerLink]="['/default-layout/molecule-analysis', element.analysisId, element.userId, {type: 'previous'}]">{{element.fileName}} </a>
              </ng-template>
            </td>
          </ng-container>
          <ng-container matColumnDef="analysisDate">
            <th mat-header-cell *matHeaderCellDef > Analysis Date (UTC Time Zone)</th>
            <td mat-cell *matCellDef="let element"> {{element.analysisDate}}</td>
          </ng-container>

          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef> Status</th>
            <td mat-cell *matCellDef="let element"> {{element.analysisStatus}} </td>
          </ng-container>
          <ng-container matColumnDef="userId">
            <th mat-header-cell *matHeaderCellDef > User ID </th>
            <td mat-cell *matCellDef="let element">{{element.userId}}
          </ng-container>
          <ng-container matColumnDef="full_name">
            <th mat-header-cell *matHeaderCellDef>Full Name</th>
            <td mat-cell *matCellDef="let element">{{element.full_name}}
          </ng-container>
          <ng-container matColumnDef="access">
            <th mat-header-cell *matHeaderCellDef> User Role </th>
            <td mat-cell *matCellDef="let element">{{element.access}}
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: tableColumns;"></tr>
        </table>
        <mat-paginator  [pageSizeOptions]="[ 10, 20, 50]" showFirstLastButtons></mat-paginator>
      </card>
    </div>
  </div>
</section>

<ng-template #logspin>
  <div>
    <met-spinner
      style="margin: 0 auto;"
      mode="indeterminate"
      [diameter]="200"
    ></met-spinner>
  </div>
</ng-template>

<ng-template #nodata>
  <h4>No data found for selected time range</h4>
</ng-template>

<!--<router-outlet name="print"></router-outlet>-->